import React from 'react';
import {DashboardManagement} from "./DashboardManagement";
import {DashboardGeneral} from "./DashboardGeneral";
import { usePermissions } from '../../../../Hooks/usePermissions';

export const Dashboard = () => {

    const {hasPermission} = usePermissions();
    
    if (hasPermission('core.dashboard.management')) {
        return <DashboardManagement />;
    }

    return <DashboardGeneral />;
}
